import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=79b01e47&"
import script from "./DashboardLayout.vue?vue&type=script&lang=js&"
export * from "./DashboardLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79b01e47')) {
      api.createRecord('79b01e47', component.options)
    } else {
      api.reload('79b01e47', component.options)
    }
    module.hot.accept("./DashboardLayout.vue?vue&type=template&id=79b01e47&", function () {
      api.rerender('79b01e47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/main-column/DashboardLayout.vue"
export default component.exports